import {observer} from 'mobx-react'
import PatientPageStore from '../Store/PatientPageStore'
import React, {useEffect, useRef, useState} from 'react'
import Button from '../../../../components/Button'
import Notify from '../../../../components/Notify'
import {toPayKeeper} from '../../../../api.external/payKeeper'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import {useAPI} from '../../../../hooks/useAPI'

const CellResult = observer(props => {
        const [actualModalState, setActualModalState] = useState({})
        const [modalVisibility, setModalVisibility] = useState(false)
        const {APIRequest} = useAPI()
        const myRef = useRef()
        const {discount} = PatientPageStore

        useOutsideClick(myRef, () => {
            modalVisibility && setModalVisibility(false)
        })

        const getPayData =
            async () => {
                await APIRequest({
                    api: `/api/v2/patients/${props.patientId}/results/${props.resultId}/order`,
                    method: 'POST'
                }).then(
                    res => {
                        res?.body?.data?.orderId
                        && toPayKeeper('', res.body.data?.price, res.body?.data?.orderId)
                    }
                )
            }


        const modalState = {
            first24Hour: {
                modalText: <>
                    <div style={{fontSize: '19px', width: '100%', textAlign: "center"}}>Внимание!</div>
                    При оплате в течении 24 часов стоимость доступа к результату составит 30 рублей.
                    Результат будет доступен на весь срок действия обследования.</>,
                buttonText: "Оплатить",
                buttonAction: _ => getPayData(),
                button2Text: "Посмотреть",
                button2Action: _ => PatientPageStore.showResultModal(props.id)
            },

            after24Hour: {
                modalText: <>
                    <div style={{fontSize: '19px', width: '100%', textAlign: "center"}}>Внимание!</div>
                    <br/>
                    Результат не оплачен.
                    <br/>
                    <br/>
                    Стоимость доступа к результату 120 рублей.
                    После оплаты результат будет доступен до конца срока действия обследования.
                </>,
                buttonText: "Оплатить",
                buttonAction: _ => getPayData()
            },
            payed: {
                modalText: `Ваш результат оплачен!`,
                buttonText: "Посмотреть",
                buttonAction: () => PatientPageStore.showResultModal(props.id)

            },
            // test: {
            //     modalText: <>
            //         <div style={{fontSize: '19px', width: '100%', textAlign: "center"}}>Внимание!</div>
            //         <br/>
            //         &nbsp;&nbsp;&nbsp; Результат доступен в тестовом режиме.
            //         <br/>
            //     </>,
            //     buttonText: `Посмотреть`,
            //     buttonAction: () => PatientPageStore.showResultModal(props.id)
            // }
        }
        useEffect(() => {

            if (props?.rowData?.discount) PatientPageStore.setDiscount(true)

            switch (props?.rowData?.can_pay) {
                case true:
                    props?.rowData?.discount
                        ? setActualModalState(modalState?.first24Hour)
                        : setActualModalState(modalState?.after24Hour)
                    break;
                case false:
                    setActualModalState(modalState?.payed)
                    break;
                default:
                    setActualModalState(modalState?.after24Hour)
            }
        }, [])


        const modalContent = () => {
            return (
                <>
                    <div style={{fontSize: '17px', textAlign: 'left'}}>
                        {actualModalState.modalText}
                    </div>


                    <div style={{display: 'flex', justifyContent: "center", flexDirection: 'row', marginTop: '20px'}}>
                        <Button size={"small"} onClick={actualModalState.buttonAction} text={actualModalState.buttonText}/>
                        {actualModalState?.button2Action && <Button size={"small"} onClick={actualModalState?.button2Action}
                                                                    text={actualModalState?.button2Text}/>}

                    </div>
                </>

            )
        }

        const availableCell = () => {
            return (
                // props?.rowData?.available && // available always when not waiting
                <Notify
                    reff={myRef}
                    notifyCloseHandler={_ => setModalVisibility(false)}
                    notifyVisibility={modalVisibility}
                    horizontalDirection={"left"}
                    verticalDirection={'bottom'}
                    notifyInner={modalContent()}
                    customStyles={{minWidth: '450px', top: '105%', marginTop: '10px', right: '10px'}}
                    customWrapperStyles={{position: 'relative', width: 'max-content'}}
                    size={'large'}>

                    <button
                        style={{height: '25px !important'}}
                        id={props.id}
                        className='result'
                        onClick={() => { 
							// setModalVisibility(true) // use modal
							PatientPageStore.showResultModal(props.id)
						} }>
                        {props?.rowData?.result == 'Без патологических изменений' ? 'Без патологий' : 'Вызов'}
                    </button>

                </Notify> 
            )
        }
        const waitingCell = () => {
            return (
                <button
                    style={{height: '25px !important'}}
                    id={props.id}
                    className='result waiting'
                    onClick={() => {
                    }}>
                    Ожидание
                </button>
            )
        }
        const addPhotoCell = () => {
            return (
                props?.rowData?.result
            )
        }
        return (
            <div className={'row__cell'}>
                {
                    props?.rowData?.result === "Ожидание"
                        ? waitingCell() 
                        : props?.rowData?.result === "Допснимок" || props?.rowData?.result === "Переснять"
						  ? addPhotoCell()
						  : availableCell()
                }

            </div>
        )
    }
)
export default CellResult